import React from 'react'
import { useSelector } from 'react-redux'
import { get } from 'lodash'
import { useNavigation } from '@react-navigation/core'
import { StackNavigationProp } from '@react-navigation/stack'
import { clientConfigStoreStateSelector } from '@src/selectors/app'
import { NavigationContainer } from '@src/screens/Common/containers'
import { sensorSelector } from '@src/selectors/sensor'
import { AppStackParamList, CommonAuthorizedStackParamList } from '@src/navigation/types'
import { MobileAppFeature } from '@src/types'
import { User } from '@src/utils'
import { SensorSettings as SensorSettingsComponent } from '../components/SensorSettings'

export const SensorSettingsContainer = () => {
  const sensor = useSelector(sensorSelector)
  const clientConfig = useSelector(clientConfigStoreStateSelector)
  const navigation = useNavigation<StackNavigationProp<AppStackParamList>>()
  const authorizedNavigation = useNavigation<StackNavigationProp<CommonAuthorizedStackParamList>>()
  const isActivateOwnSensorFeatureAvailable = User.hasFeature(MobileAppFeature.ActivateOwnSensor)

  const onActivateSensorPress = () => {
    if (isActivateOwnSensorFeatureAvailable) {
      authorizedNavigation.navigate('OwnSensorSelection', { nextScreen: 'ConfirmSensorSelection' })
      return
    }
  }

  const onCalibrateSensorPress = () => {
    navigation.navigate('CalibrateSensor')
  }

  const onIconPress = () => {
    const tutorial = get(clientConfig, 'onboarding.tutorials.calibration', undefined)
    if (tutorial) {
      navigation.navigate('ShowTutorial', { tutorial })
    }
  }

  const onGetMoreSensorsPress = () => {
    navigation.navigate('Subscriptions')
  }

  return (
    <NavigationContainer title="Sensor Settings" showLoadingIndicator>
      <SensorSettingsComponent
        sensor={sensor}
        activateDisabled={!isActivateOwnSensorFeatureAvailable}
        onActivateSensorPress={onActivateSensorPress}
        onCalibrateSensorPress={onCalibrateSensorPress}
        onIconPress={onIconPress}
        onGetMoreSensorsPress={onGetMoreSensorsPress}
      />
    </NavigationContainer>
  )
}
